
export default {
  name: 'ClientNotification',
  computed: {
    notifications() {
      return this.$notifications.getNotifications()
    }
  },

  methods: {
    handleButtonClick(callback, reset, id) {
      if (callback) {
        callback()
      }
      reset(id)
    }
  }
}
